import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Phone, Instagram, Facebook } from 'lucide-react';
import usePageMeta from './hooks/usePageMeta';
import './App.css';

function LandingIgreenAP() {
  usePageMeta("Igreen - AP", "pp");
  
  const navigate = useNavigate();
  const [faqOpen, setFaqOpen] = useState({});

  // Meta Pixel - carrega apenas uma vez na montagem do componente
  useEffect(() => {
    // Verificar se o pixel já foi carregado para evitar duplicação
    if (window.fbq) return;

    // Criar e injetar o script do Meta Pixel
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1782304475789960');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);

    // Adicionar noscript fallback
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.net/tr?id=1782304475789960&ev=PageView&noscript=1"/>`;
    document.head.appendChild(noscript);

    // Cleanup ao desmontar o componente
    return () => {
      if (script.parentNode) script.parentNode.removeChild(script);
      if (noscript.parentNode) noscript.parentNode.removeChild(noscript);
    };
  }, []);

  const toggleFaq = (index) => {
    setFaqOpen(prev => ({ ...prev, [index]: !prev[index] }));
  };

  const scrollToFooter = () => {
    window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
  };

  const faqData = [
    {
      q: "É realmente gratuito me cadastrar na Igreen Energy?",
      a: "Sim. O cadastro é totalmente gratuito, 100% digital e sem fidelidade. Você não paga absolutamente nada para se cadastrar."
    },
    {
      q: "Quem decide se meu cadastro será aprovado?",
      a: "A aprovação é definida exclusivamente pela Igreen Energy, seguindo critérios internos da empresa. A PP não interfere nessa decisão."
    },
    {
      q: "O que acontece se meu cadastro for aprovado?",
      a: "Você ganha o acesso vitalício ao AP – Finanças Pessoais, totalmente gratuito, enquanto você estiver ativo na Igreen."
    },
    {
      q: "O que acontece se eu não for aprovado?",
      a: "A PP entra em contato e você ainda recebe um bônus para acessar a plataforma de finanças pessoais. Ou seja, você não sai perdendo."
    },
    {
      q: "O AP – Finanças Pessoais é realmente completo?",
      a: "Sim. Ele inclui controle de investimentos, metas, patrimônio, gastos, receitas, proventos, dashboard, parcelamentos e muito mais — com melhorias contínuas."
    },
    {
      q: "Quanto custa normalmente o AP – Finanças Pessoais?",
      a: "O valor atual é R$ 1.200,00 na compra única ou R$ 9,90/mês na versão por assinatura. Mas nesta promoção, você recebe tudo de graça se for aprovado."
    },
    {
      q: "Preciso instalar algo?",
      a: "Não. O sistema é totalmente online, pode ser acessado pelo navegador do celular ou computador."
    },
    {
      q: "O desconto da Igreen é garantido?",
      a: "Sim. Ele é garantido pela Lei 14.300, que obriga a distribuidora a aplicar o crédito de energia na sua fatura mensal."
    },
    {
      q: "Preciso fidelidade com a Igreen?",
      a: "Não. Não existe fidelidade. Você pode cancelar quando quiser."
    },
    {
      q: "O acesso vitalício é realmente vitalício?",
      a: "Sim, você terá acesso enquanto estiver cadastrado e ativo na Igreen."
    },
    {
      q: "Quanto tempo demora para ser aprovado?",
      a: "O processo costuma ser rápido, mas depende da análise da Igreen Energy."
    },
    {
      q: "Eu corro algum risco nesta promoção?",
      a: "Não. O cadastro é gratuito, a economia na conta de luz é real e, caso não seja aprovado, você ainda recebe bônus para usar o software."
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header Simplificado (sem navegação) */}
      <header className="bg-gradient-to-r from-green-600 to-emerald-700 text-white py-4 shadow-lg sticky top-0 z-50">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-center">
            <div className="text-2xl font-bold">⚡ Promoção Igreen + AP</div>
          </div>
        </div>
      </header>

      {/* FAIXA 1 - HERO */}
      <section className="relative bg-gradient-to-br from-green-600 via-emerald-600 to-teal-700 text-white py-20 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%23ffffff\' fill-opacity=\'0.4\'%3E%3Cpath d=\'M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")'
          }}></div>
        </div>
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight animate-fade-in">
              Economize na conta de luz e ganhe acesso vitalício ao melhor software de finanças pessoais do Brasil
            </h1>
            
            <p className="text-xl md:text-2xl mb-8 leading-relaxed opacity-95">
              Cadastro <strong>100% gratuito</strong> na Igreen Energy. Sendo aprovado, você recebe <strong>gratuitamente</strong> o AP – Finanças Pessoais, avaliado em <strong>R$ 1.200,00</strong> e cujo acesso normal custa <strong>R$ 9,90/mês</strong> — mas para você será <strong className="text-yellow-300">VITALÍCIO</strong> enquanto estiver ativo na Igreen.
            </p>

            {/* Vídeo Hero */}
            <div className="mb-8 max-w-3xl mx-auto">
              <div className="relative w-full rounded-xl overflow-hidden shadow-2xl" style={{ paddingTop: '56.25%' }}>
                <iframe 
                  src="https://www.youtube.com/embed/yqWfhHXiw0g" 
                  className="absolute top-0 left-0 w-full h-full"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  title="Vídeo Igreen Energy"
                ></iframe>
              </div>
            </div>

            {/* Lista de Benefícios */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8 max-w-2xl mx-auto">
              {[
                "✔ Promoção exclusiva",
                "✔ Sem custo para cadastro",
                "✔ Economia real na conta de energia",
                "✔ Acesso vitalício ao AP – Finanças Pessoais"
              ].map((item, i) => (
                <div key={i} className="bg-white/10 backdrop-blur-sm px-6 py-3 rounded-lg text-lg font-medium">
                  {item}
                </div>
              ))}
            </div>

            <button
              onClick={() => navigate('/igreencadastroap')}
              className="bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-bold text-xl px-8 py-4 rounded-full shadow-2xl hover:shadow-yellow-500/50 transition-all duration-300 transform hover:scale-105"
            >
              Quero economizar e garantir meu acesso vitalício
            </button>
          </div>
        </div>
      </section>

      {/* FAIXA 2 - STORYTELLING */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="prose prose-lg max-w-none">
              <p className="text-xl leading-relaxed text-gray-700 mb-6">
                <strong className="text-2xl text-gray-900">A realidade atual:</strong> Contas altas, inflação galopante, juros nas alturas, energia elétrica cada vez mais cara. E no meio disso tudo, a <strong>falta de organização financeira</strong> deixa você perdido, sem saber para onde o dinheiro está indo.
              </p>
              
              <p className="text-xl leading-relaxed text-gray-700 mb-6">
                Mas e se existisse uma <strong className="text-green-600">virada de chave</strong>? Uma forma de ter <strong>energia mais barata</strong> + <strong>controle financeiro profissional</strong> ao mesmo tempo?
              </p>
              
              <p className="text-xl leading-relaxed text-gray-700 mb-6">
                Descubra você também a combinação perfeita: <strong>Igreen Energy</strong> + <strong>AP – Finanças Pessoais</strong>.
              </p>
              
              <div className="bg-gradient-to-r from-green-50 to-emerald-50 p-8 rounded-2xl my-8 border-l-4 border-green-600">
                <p className="text-xl leading-relaxed text-gray-800 mb-4">
                  ✅ Passam a <strong>economizar até 15% todo mês</strong> automaticamente na conta de luz
                </p>
                <p className="text-xl leading-relaxed text-gray-800 mb-4">
                  ✅ Têm <strong>controle total</strong> do dinheiro, metas, investimentos e patrimônio
                </p>
                <p className="text-xl leading-relaxed text-gray-800">
                  ✅ Começam a <strong>juntar para o futuro</strong> sem sofrimento
                </p>
              </div>
              
              <p className="text-2xl font-bold text-center text-gray-900 my-10 italic">
                "Quando a economia se une à organização financeira, o resultado é liberdade real."
              </p>
            </div>
            
            <div className="text-center mt-10">
              <button
                onClick={() => navigate('/igreencadastroap')}
                className="bg-green-600 hover:bg-green-700 text-white font-bold text-lg px-8 py-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
              >
                Quero aproveitar agora
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* FAIXA 3 - BENEFÍCIOS AP */}
      <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              💼 Benefícios do AP – Finanças Pessoais
            </h2>
            <div className="bg-yellow-100 border-l-4 border-yellow-500 p-6 max-w-3xl mx-auto my-8 rounded-lg">
              <p className="text-xl font-bold text-gray-900 mb-2">
                O AP – Finanças Pessoais custa <span className="text-red-600">R$ 1.200,00</span> na compra única ou <span className="text-red-600">R$ 9,90/mês</span> no plano mensal.
              </p>
              <p className="text-2xl font-bold text-green-600">
                Mas você ganha o acesso TOTALMENTE de graça se seu cadastro na Igreen for aprovado.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
            {[
              { icon: "📊", title: "Controle de Investimentos", desc: "Brasil e Exterior" },
              { icon: "💰", title: "Controle de Gastos", desc: "Mensais detalhados" },
              { icon: "📈", title: "Gestão Completa", desc: "Receitas e despesas com foco em economia para investimentos (margem de 30%)" },
              { icon: "💸", title: "Gestão de Proventos", desc: "Acompanhe seus rendimentos" },
              { icon: "📱", title: "Dashboard Intuitivo", desc: "Resumo completo e visual" },
              { icon: "🎯", title: "Metas Personalizadas", desc: "Alcance seus objetivos" },
              { icon: "✈️", title: "Orçamento para Viagens", desc: "Planeje suas viagens" },
              { icon: "🛒", title: "Compras Parceladas", desc: "Controle total de parcelas" },
              { icon: "🏠", title: "Controle de Patrimônio", desc: "Acompanhe seu crescimento" },
              { icon: "🔄", title: "Melhorias Contínuas", desc: "Sempre evoluindo" },
              { icon: "👨‍💼", title: "Consultoria Futura", desc: "Em desenvolvimento" },
              { icon: "🚫", title: "Sem Fidelidade", desc: "Cancele quando quiser" }
            ].map((item, i) => (
              <div key={i} className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 border border-gray-100">
                <div className="text-4xl mb-3">{item.icon}</div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-gray-600">{item.desc}</p>
              </div>
            ))}
          </div>

          {/* Imagens do software */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
            <div className="bg-gray-100 rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
              <img 
                src="https://customer-assets.emergentagent.com/job_d252bcf0-fa70-4731-a84b-2154815486b7/artifacts/qyvmmnbd_Tela%20de%20dashboard.png" 
                alt="Dashboard AP - Finanças Pessoais" 
                className="w-full h-64 object-cover"
              />
              <div className="p-3 bg-white">
                <p className="text-center font-medium text-gray-800">Dashboard Completo</p>
              </div>
            </div>
            <div className="bg-gray-100 rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
              <img 
                src="https://customer-assets.emergentagent.com/job_d252bcf0-fa70-4731-a84b-2154815486b7/artifacts/o74ersy2_Menu%20investimento.png" 
                alt="Gestão de Investimentos" 
                className="w-full h-64 object-cover"
              />
              <div className="p-3 bg-white">
                <p className="text-center font-medium text-gray-800">Controle de Investimentos</p>
              </div>
            </div>
          </div>

          <div className="text-center">
            <button
              onClick={() => navigate('/igreencadastroap')}
              className="bg-blue-600 hover:bg-blue-700 text-white font-bold text-lg px-8 py-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
            >
              Quero meu acesso gratuito
            </button>
          </div>
        </div>
      </section>

      {/* FAIXA 4 - FUTUROS BENEFÍCIOS */}
      <section className="py-20 bg-gradient-to-r from-purple-50 to-indigo-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              🌟 Benefícios Futuros
            </h2>
            <p className="text-xl text-gray-700 mb-4">
              <span className="bg-yellow-200 px-3 py-1 rounded-full font-semibold">Em breve!</span>
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            {[
              { icon: "🎓", title: "Vídeo Aulas", desc: "Finanças pessoais do zero ao avançado" },
              { icon: "🎁", title: "Descontos Exclusivos", desc: "Produtos e serviços parceiros" },
              { icon: "💼", title: "Revenda AP", desc: "Gere renda extra revendendo" }
            ].map((item, i) => (
              <div key={i} className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
                <div className="text-5xl mb-4">{item.icon}</div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{item.title}</h3>
                <p className="text-gray-600 mb-4">{item.desc}</p>
                <div className="inline-block bg-purple-100 text-purple-700 px-3 py-1 rounded-full text-sm font-medium">
                  Em desenvolvimento
                </div>
              </div>
            ))}
          </div>

          <div className="bg-white p-6 rounded-xl shadow-lg max-w-2xl mx-auto text-center mb-8">
            <p className="text-xl font-bold text-gray-900">
              💡 Recursos em desenvolvimento. Quem entrar agora será um dos primeiros a receber esses benefícios extras.
            </p>
          </div>

          <div className="text-center">
            <button
              onClick={() => navigate('/igreencadastroap')}
              className="bg-purple-600 hover:bg-purple-700 text-white font-bold text-lg px-8 py-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
            >
              Quero entrar antes das próximas atualizações
            </button>
          </div>
        </div>
      </section>

      {/* FAIXA 5 - BENEFÍCIOS IGREEN */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              ⚡ Benefícios da Igreen Energy
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
            {[
              { icon: "💰", title: "Até 15% de Desconto", desc: "Economize todo mês automaticamente" },
              { icon: "📄", title: "Menos Boletos", desc: "Economia de 1 a 2 boletos por ano" },
              { icon: "🎉", title: "Cadastro Gratuito", desc: "100% digital e sem custos" },
              { icon: "🚫", title: "Sem Fidelidade", desc: "Cancele quando quiser" },
              { icon: "🌱", title: "Energia Sustentável", desc: "Direto de usinas solares" },
              { icon: "📱", title: "App Igreen Club", desc: "Cashback e sorteios" },
              { icon: "✅", title: "Processo Fácil", desc: "Rápido e totalmente digital" }
            ].map((item, i) => (
              <div key={i} className="bg-gradient-to-br from-green-50 to-emerald-50 p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 border border-green-100">
                <div className="text-4xl mb-3">{item.icon}</div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-gray-700">{item.desc}</p>
              </div>
            ))}
          </div>

          <div className="text-center">
            <button
              onClick={() => navigate('/igreencadastroap')}
              className="bg-green-600 hover:bg-green-700 text-white font-bold text-lg px-8 py-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
            >
              Quero economizar agora
            </button>
          </div>
        </div>
      </section>

      {/* FAIXA 6 - LEI 14.300 */}
      <section className="py-20 bg-gradient-to-br from-blue-600 to-indigo-700 text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl md:text-5xl font-bold text-center mb-12">
              ⚖️ A Lei 14.300 Garante Seu Desconto
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
              <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl">
                <div className="text-4xl mb-4">1️⃣</div>
                <h3 className="text-xl font-bold mb-2">Fim do Monopólio</h3>
                <p>Você pode comprar energia de usinas solares</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl">
                <div className="text-4xl mb-4">2️⃣</div>
                <h3 className="text-xl font-bold mb-2">Obrigação de Entrega</h3>
                <p>A distribuidora deve abater sua energia solar da fatura</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl">
                <div className="text-4xl mb-4">3️⃣</div>
                <h3 className="text-xl font-bold mb-2">Segurança Jurídica</h3>
                <p>Agora é Lei Federal</p>
              </div>
            </div>

            <div className="bg-yellow-400 text-gray-900 p-8 rounded-2xl shadow-2xl">
              <p className="text-2xl font-bold text-center">
                📜 A Lei 14.300 garante o direito de economizar: você compra energia mais barata de fora e a distribuidora é obrigada a descontar do seu boleto.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* FAIXA 7 - PROVA SOCIAL */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              🧩 Números que Provam
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <div className="text-center p-8 bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl shadow-lg">
              <div className="text-5xl font-bold text-green-600 mb-2">170.000+</div>
              <p className="text-xl text-gray-700">Clientes Ativos</p>
            </div>
            <div className="text-center p-8 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl shadow-lg">
              <div className="text-5xl font-bold text-blue-600 mb-2">R$ 70M+</div>
              <p className="text-xl text-gray-700">Em Economia Gerada</p>
            </div>
            <div className="text-center p-8 bg-gradient-to-br from-emerald-50 to-teal-50 rounded-xl shadow-lg">
              <div className="text-5xl font-bold text-emerald-600 mb-2">100%</div>
              <p className="text-xl text-gray-700">Energia Sustentável</p>
            </div>
          </div>

          <div className="text-center">
            <button
              onClick={() => navigate('/igreencadastroap')}
              className="bg-green-600 hover:bg-green-700 text-white font-bold text-lg px-8 py-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
            >
              Quero participar também
            </button>
          </div>
        </div>
      </section>

      {/* FAIXA 8 - COMO FUNCIONA */}
      <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              🎁 Como Funciona a Promoção
            </h2>
          </div>

          <div className="max-w-4xl mx-auto">
            <div className="space-y-6 mb-10">
              <div className="flex items-start gap-4 bg-white p-6 rounded-xl shadow-md">
                <div className="flex-shrink-0 w-12 h-12 bg-green-600 text-white rounded-full flex items-center justify-center text-xl font-bold">
                  1
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Você se cadastra na Igreen</h3>
                  <p className="text-gray-700">Totalmente gratuito e digital</p>
                </div>
              </div>

              <div className="flex items-start gap-4 bg-white p-6 rounded-xl shadow-md">
                <div className="flex-shrink-0 w-12 h-12 bg-blue-600 text-white rounded-full flex items-center justify-center text-xl font-bold">
                  2
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">A Igreen analisa e aprova</h3>
                  <p className="text-gray-700">A aprovação é decidida exclusivamente pela Igreen Energy</p>
                </div>
              </div>

              <div className="flex items-start gap-4 bg-green-50 p-6 rounded-xl shadow-md border-2 border-green-500">
                <div className="flex-shrink-0 w-12 h-12 bg-green-600 text-white rounded-full flex items-center justify-center text-xl font-bold">
                  3
                </div>
                <div>
                  <h3 className="text-xl font-bold text-green-700 mb-2">✅ Se APROVADO:</h3>
                  <p className="text-gray-900 font-medium">Ganha o AP – Finanças Pessoais vitalício enquanto estiver ativo</p>
                </div>
              </div>

              <div className="flex items-start gap-4 bg-yellow-50 p-6 rounded-xl shadow-md border-2 border-yellow-500">
                <div className="flex-shrink-0 w-12 h-12 bg-yellow-600 text-white rounded-full flex items-center justify-center text-xl font-bold">
                  4
                </div>
                <div>
                  <h3 className="text-xl font-bold text-yellow-700 mb-2">⚠️ Se NÃO for aprovado:</h3>
                  <p className="text-gray-900 font-medium">A empresa PP entra em contato e você ainda recebe um bônus para acessar a plataforma</p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-r from-green-600 to-emerald-600 text-white p-8 rounded-2xl shadow-xl text-center">
              <p className="text-3xl font-bold">
                🎯 Nessa promoção você só ganha. Zero riscos.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* FAIXA 9 - BOTÃO WHATSAPP */}
      <section className="py-12 bg-green-600">
        <div className="container mx-auto px-4 text-center">
          <button
            onClick={scrollToFooter}
            className="bg-white hover:bg-gray-100 text-green-600 font-bold text-lg px-8 py-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 inline-flex items-center gap-3"
          >
            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z" clipRule="evenodd" />
            </svg>
            Tirar dúvidas / Falar com suporte
          </button>
        </div>
      </section>

      {/* FAIXA 10 - FAQ */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              ❓ Perguntas Frequentes
            </h2>
          </div>

          <div className="max-w-3xl mx-auto space-y-4">
            {faqData.map((faq, index) => (
              <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden">
                <button
                  onClick={() => toggleFaq(index)}
                  className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-50 transition-colors"
                >
                  <span className="font-semibold text-gray-900 pr-4">{faq.q}</span>
                  <svg
                    className={`w-5 h-5 text-gray-600 flex-shrink-0 transition-transform ${faqOpen[index] ? 'rotate-180' : ''}`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                {faqOpen[index] && (
                  <div className="px-6 py-4 bg-gray-50 border-t border-gray-200">
                    <p className="text-gray-700">{faq.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAIXA FINAL - CTA FINAL */}
      <section className="py-20 bg-gradient-to-br from-green-600 via-emerald-600 to-teal-700 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-8">
            🎯 Você só tem a ganhar
          </h2>
          <p className="text-2xl mb-10 max-w-2xl mx-auto">
            Aproveite enquanto essa promoção ainda está ativa
          </p>
          <button
            onClick={() => navigate('/igreencadastroap')}
            className="bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-bold text-xl px-10 py-5 rounded-full shadow-2xl hover:shadow-yellow-500/50 transition-all duration-300 transform hover:scale-105"
          >
            Quero economizar e ganhar meu acesso vitalício agora
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-8 mb-8">
            {/* Logo e Descrição */}
            <div>
              <img 
                src="https://customer-assets.emergentagent.com/job_finance-dash-68/artifacts/7w39hvkz_Logo%20PP%20sem%20fundo.png" 
                alt="Pavan e Parazzi" 
                className="h-16 w-auto mb-4 brightness-0 invert"
              />
              <p className="text-gray-400 text-sm">
                Soluções em tecnologia e serviços integrados para impulsionar seu negócio e vida pessoal.
              </p>
            </div>

            {/* Links */}
            <div>
              <h3 className="text-lg font-semibold mb-4">Links Úteis</h3>
              <ul className="space-y-2">
                <li>
                  <a href="#" className="text-gray-400 hover:text-white transition-colors">
                    Termos de Uso
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-400 hover:text-white transition-colors">
                    Política de Privacidade
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-400 hover:text-white transition-colors">
                    Contato
                  </a>
                </li>
              </ul>
            </div>

            {/* Redes Sociais */}
            <div>
              <h3 className="text-lg font-semibold mb-4">Conecte-se</h3>
              <div className="flex space-x-4 mb-4">
                <a 
                  href="https://www.instagram.com/pavaneparazzi" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="bg-gray-800 p-3 rounded-full hover:bg-pink-600 transition-colors"
                >
                  <Instagram size={24} />
                </a>
                <a 
                  href="https://www.facebook.com/pavaneparazzi" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="bg-gray-800 p-3 rounded-full hover:bg-blue-600 transition-colors"
                >
                  <Facebook size={24} />
                </a>
                <a 
                  href="https://wa.me/5519920008711" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="bg-gray-800 p-3 rounded-full hover:bg-green-600 transition-colors"
                >
                  <Phone size={24} />
                </a>
              </div>
              <p className="text-gray-400 text-sm">
                <Phone size={16} className="inline mr-2" />
                (19) 9 2000-8711
              </p>
            </div>
          </div>

          {/* Copyright */}
          <div className="border-t border-gray-800 pt-8 text-center">
            <p className="text-gray-400 text-sm">
              © 2025 Pavan e Parazzi – Todos os direitos reservados.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default LandingIgreenAP;
